'use strict';

import 'bootstrap/dist/js/bootstrap.bundle';
import 'jquery';
import 'jquery-slimscroll/jquery.slimscroll';

const constants = require('../../../helpers/constants');
const dataFormatter = require('../../../helpers/data-formatter');

import Promise from 'bluebird';
import utils from './utils';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';
import SimpleVueValidator from 'simple-vue-validator';

//SimpleVueValidator.setMode('conservative');

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(SimpleVueValidator, {Promise: Promise});

Vue.http.interceptors.push((request, next) => {
  if (!request.url.startsWith('/api/login') && !request.url.startsWith('/api/register') && !request.url.startsWith('/api/me/password')) {
    return next(response => {
      if (response.status === 401) {
        Vue.http.post('/api/logout').then(() => {
          window.location.href = '/';
        });
      }
    });
  }
  next();
});

Vue.mixin({
  filters: dataFormatter,
  beforeCreate() {
    this.$formatter = dataFormatter;
    this.$constants = constants;
    this.$utils = utils;
    this.$debounce = (methodName, interval) => {
      interval = interval || 200;
      let internalMethodName = `$__debounced_${methodName}`;
      if (!this[internalMethodName]) {
        this[internalMethodName] = _.debounce(() => this[methodName](), interval);
      }
      this[internalMethodName]();
    };
    this.$breakUpdateLoop = async function (code) {
      if (this._dataUpdating) {
        return;
      }
      this._dataUpdating = true;
      try {
        await code();
      } finally {
        await Vue.nextTick();
        this._dataUpdating = false;
      }
    };
  }
});

Vue.http.interceptors.push((request, next) => {
  // for fucking IE, fuck you microsoft!!!
  request.url += (request.url.indexOf('?') > 0 ? '&' : '?') + `v=${new Date().getTime()}`;
  next();
});




// WEBPACK FOOTER //
// ./client/app/scripts/bootstrap.js